/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import { kebabCase } from "lodash";
import { FormControl, MenuItem, Select } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";

import { HelperText } from "./styles";

const BasicSelect = ({
  onSelectOpen,
  onSelectClose,
  paddingTop,
  overflow,
  error,
  helperText,
  items,
  label,
  fieldSize,
  value,
  handleSelect,
  minWidth,
  maxWidth,
  width,
  marginVertical,
  borderRadius,
  disableField,
  marginRight,
  ...props
}) => {
  return (
    <FormControl
      size={fieldSize}
      fullWidth={props.fullWidth}
      sx={{
        marginBottom: marginVertical || 0,
        marginTop: marginVertical || 0,
        minWidth: minWidth || 0,
        maxWidth: maxWidth || 0,
        width: width || 0,
        marginRight: marginRight || 0,
      }}
    >
      <InputLabel sx={{ top: "-8px" }} id="demo-simple-select-label">
        {label}
      </InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={value}
        label="Age"
        onChange={handleSelect}
        required
        error={error}
        helperText={helperText}
        disabled={disableField}
        onOpen={onSelectOpen}
        onClose={onSelectClose}
        sx={{
          borderColor: error ? "red" : "black",
          borderRadius: borderRadius || 0,
          height: "44px",
          paddingTop: paddingTop,
          overflow: overflow,
        }}
        MenuProps={{
          sx: {
            "& .Mui-selected": {
              backgroundColor: "#F5F5F5 !important",
              color: "black",
            },
            "& .MuiMenu-paper": {
              backgroundColor: "#F5F5F5",
              borderRadius: 0,
              borderTop: "0.4px solid rgba(112, 112, 112, 0.1)",
              boxShadow: 0,
              color: "#707070",
              maxHeight: "40vh",
            },
          },
        }}
        {...props}
      >
        {items.map((item) => (
          <MenuItem
            data-testid={`menu-item-${kebabCase(item.name)}-${items.indexOf(
              item
            )}`}
            key={items.indexOf(item)}
            value={item.value}
          >
            {item.name}
          </MenuItem>
        ))}
      </Select>
      {error && <HelperText>{helperText}</HelperText>}
    </FormControl>
  );
};

export default BasicSelect;
